<template>
  <DropdownMenu>
    <DropdownMenuTrigger>
      <AppActionButton
        :button-class="props.full ? 'w-full justify-start' : ''"
        :icon="colorMode.value === 'light' ? Sun : Moon"
        :size="props.full ? 'default' : 'icon'"
        :tooltip="!props.full ? $t('components.theme_switcher.toggle_theme') : undefined"
      >
        <template v-if="props.full">
          {{ $t('components.theme_switcher.toggle_theme') }}
        </template>
      </AppActionButton>
    </DropdownMenuTrigger>

    <DropdownMenuContent align="end">
      <DropdownMenuItem @click="colorMode.preference = 'light'">{{
        $t('components.theme_switcher.light')
      }}</DropdownMenuItem>
      <DropdownMenuItem @click="colorMode.preference = 'dark'">{{
        $t('components.theme_switcher.dark')
      }}</DropdownMenuItem>
      <DropdownMenuItem @click="colorMode.preference = 'system'">{{
        $t('components.theme_switcher.system')
      }}</DropdownMenuItem>
    </DropdownMenuContent>
  </DropdownMenu>
</template>

<script setup lang="ts">
import { Moon, Sun } from 'lucide-vue-next';

const colorMode = useColorMode();

const props = defineProps<{
  full?: boolean;
}>();
</script>
